export const environment = {
  production : true,
  wpApiUrl: 'https://api.visitvar.fr/wp-json',
  synapiApiUrl: 'https://synapi.visitvar.fr/api/',
  bookmarkFrUrl: '/favoris',
  bookmarkEnUrl: '/bookmarks',
  webcamsFrUrl: '/preparer-visite/informer/webcams',
  webcamsEnUrl: '/preparing-your-visit/find-out-more/webcams',
};
